<template>
  <div class="acomodar">
    <div class="container-fluid py-4 px-4">


      <div class="card shadow-sm mb-3">
        <div class="card-body">
          <div class="row g-4 align-items-center">
            <div class="col-12 col-md-6">
              <form @submit.prevent="GuardarPerfil">

                <h5 class="fw-bold text-secondary mb-3 text-center ">
                  CREACIÓN DE PERFIL
                </h5>

                <label class="fw-bold d-flex align-items-center gap-2 mb-1 reducirTamaño">
                  <i class="bi bi-building text-secondary fs-6"></i> NOMBRE DEL PERFIL:
                </label>

                <input type="text" class="form-control py-2 mb-2" required v-model="perfilNombre"
                  placeholder="Ingresar nombre del perfil" />

                   <div class="col-12 col-md-4 d-flex align-items-center">
               <button class="btn btn-success d-flex justify-content-center align-items-center ms-2"
                    style="width: 48px; height: 48px;">
                    <i class="bi bi-save fs-6"></i>
                  </button>
              </div>

              </form>
            </div>


            <div class="col-12 col-md-6 d-flex justify-content-center">
              <div class="text-center">
                <i class="bi bi-person-badge fs-1 text-secondary"></i>
                <p class="text-muted mt-2">Registrar un nuevo perfil para el sistema</p>
              </div>
            </div>

          </div>

        </div>
      </div>




      <div class="border border-1 rounded-3 p-3 mb-3">
        <TablaPerfil />
      </div>





      <div class="mx-2">
        <hr />
      </div>
 <div class="border border-1 rounded-3 p-3 mb-3 shadow-sm bg-white">

        <h5 class="fw-bold text-secondary mb-4 text-uppercase">
          Categoría por Perfil
        </h5>

        <form @submit.prevent="CategoriaxPerfil">

          <div class="row g-3">


            <div class="col-12 col-md-6">
              <div class="d-flex flex-column flex-sm-row align-items-sm-center">
                <label class="text-secondary fw-semibold mb-1 mb-sm-0 me-sm-3" style="width: 120px;">
                  CATEGORIA:
                </label>

                <select required @change="idCategoria = $event.target.value" class="form-select">
                  <option value="" disabled selected>--SELECCIONAR CATEGORIA--</option>
                  <option v-for="item in ListaCategorias" :key="item.idCategoria" :value="item.idCategoria">
                    {{ item.catNombre }}
                  </option>
                </select>
              </div>
            </div>

            <div class="col-12 col-md-6">
              <div class="d-flex flex-column flex-sm-row align-items-sm-center">
                <label class="text-secondary fw-semibold mb-1 mb-sm-0 me-sm-3" style="width: 120px;">
                  PERFIL:
                </label>

                <select required @change="idPerfil = $event.target.value" class="form-select">
                  <option value="" disabled selected>--SELECCIONAR PERFIL--</option>
                  <option v-for="item in ListaPerfil" :key="item.idPerfil" :value="item.idPerfil">
                    {{ item.perNombre }}
                  </option>
                </select>
              </div>
            </div>

          </div>


          <div class="text-end mt-4">
            <button class="btn btn-success px-4 py-1">
              <i class="bi bi-save me-1 fs-5"></i>

            </button>
          </div>

        </form>
      </div>

      
      <div class="border border-1 rounded-3 p-3 mb-3">
        <TablaCatexperfil />
      </div>
    </div>
  </div>


</template>

<script>

import { mapActions, mapGetters } from "vuex";

import TablaCatexperfil from "@/components/Configuracion/Tablas/TablaCatexperfil.vue";
import TablaPerfil from "@/components/Configuracion/Tablas/tablaPerfil.vue";

import Swal from "sweetalert";
import Swal2 from "sweetalert2";
export default {
  name: "PowerbyConfiguracionAcceso",
  components: {
    TablaPerfil,
    TablaCatexperfil,
    
  },

  data() {
    return {
      perfilNombre: "",
      idUsuario: "",
      idCategoria: "",
      idPerfil: "",
      usuarios: [],
      idUsuarios: "",
    };
  },

  mounted() {
    this.idUsuario = localStorage.getItem("userId");
    this.axios.get(`BIClientes/ListadoIconos`).then((r) => {
      console.log(r.data);
      this.icons = r.data;
    });

    
  },

  computed: {
    ...mapGetters('acciones', ['ListaModulos', 'ListaCategorias', 'ListaPerfil']),

  },

  created() {
  },

  methods: {
    ...mapActions("users", ["getAttributes"]),
    ...mapActions("acciones", ["ListarPerfil", "ListarCatxPerfil", "ListarPerfilxUsuario"]),


    GuardarPerfil() {
      const from = {
        idUsuario: this.idUsuario,
        perNombre: this.perfilNombre,
      };

      this.axios.post(`BIClientes/RegistrarPerfil`, from).then((r) => {
        console.log(r.data);
        if (r.data) {
          Swal(`Se registró el perfil ${this.perfilNombre}`, "", "success");
          this.perfilNombre = "";
          this.ListarPerfil();
        } else {
          Swal2.fire({
            icon: "error",
            title: `EL PERFIL ${this.perfilNombre} YA EXISTE`,
            text: "",
            footer: "",
          });
        }
      });
    },

    CategoriaxPerfil() {
      const from = {
        idUsuario: this.idUsuario,
        idCategoria: this.idCategoria,
        idPerfil: this.idPerfil,
      };

      console.log(from);
      this.axios.post(`BIClientes/RegistrarCatxPerfil`, from).then((r) => {
        console.log(r.data);
        if (r.data) {
          Swal(`Se registro cambios`, "", "success");
          this.ListarCatxPerfil()
        } else {
          Swal2.fire({
            icon: "error",
            title: `LA CATEGORIA Y EL PERFIL SELECCIONADOS YA SE ENCUENTRAN ASOCIADOS`,
            text: "",
            footer: "",
          });
        }
      });
    },

    GuardarAcceso() {
      const from = {
        idUsuario: this.idUsuarios,
        idPerfil: this.idPerfil,
        idUsuCreacion: this.idUsuario,
      };
      console.log(from);
      this.axios.post(`BIClientes/RegistrarAcceso`, from).then((r) => {
        console.log(r.data);
        if (r.data) {
          this.ListarPerfilxUsuario()
          Swal(`Se registro cambios`, "", "success");
        } else {
          Swal2.fire({
            icon: "error",
            title: "EL USUARIO YA ESTA ASOCIADO A UN PERFIL",
            text: "",
            footer: '',
          });
        }
      });
    },
  },
};
</script>

<style scoped>
.acomodar {
  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
  margin-top: 9px;
  margin-bottom: 8px;
  padding-bottom: 5%;
  width: 100%;
  background: rgb(255, 255, 255);
  margin-left: 0.25%;
  margin-right: 10px;

  border-radius: 10px;
  /* QUITAR ESTOS DOS ↓↓↓ */
  /* height: 100vh; */
  /* overflow-y: auto; */

  /* Dejar solo si quieres evitar barra horizontal */
  overflow-x: hidden;
}

strong {
  font-size: 1.64rem;
  color: black;
}
</style>
